import { CompanyData as CompanyDataType } from './../types/constants';
import { sideProjectsData } from './sideProjects/index';

export const SideProjects: CompanyDataType[] = [sideProjectsData];
